<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="black" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title>
                  Delivery Charge
                  <v-spacer></v-spacer>
                </v-card-title>
              </v-card>
             
              <v-layout wrap style="align-items: center" justify-start>
                <v-flex xs6 sm6 md6 v-for="(item, i) in delivery" :key="i" pa-2>
                  <v-card>
                    <v-layout wrap justify-start py-5>
                      <v-flex xs12 sm6 md4>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span
                              style="font-size: 15px; color: #52504f; font-weight:bold"
                              >Min.KM</span
                            >
                          </v-flex>
                          <v-flex xs12>
                            <span><b>{{ item.minKm }}</b></span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span
                              style="font-size: 15px; color: #52504f; font-weight:bold"
                              >Max.KM</span
                            >
                          </v-flex>
                          <v-flex xs12>
                            <span><b>{{ item.maxKm }}</b></span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-btn
                          block
                         
                          small
                          depressed
                          outlined
                          color="yellow"
                          rounded

                          :ripple="false"
                          @click="editCategoryDialog(item)"
                          class="itemValue"
                        >
                          <span style="color: black"> Edit </span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      wrap
                      justify-center
                      v-for="(list, j) in item.weight"
                      :key="j"
                      pb-2
                    >
                      <v-flex xs12 sm6 md4>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span style="font-size: 13px; color: #8e8e8e"
                              >Min.KG</span
                            >
                          </v-flex>
                          <v-flex xs12>
                            <span><b>{{ list.minKg }}</b></span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span style="font-size: 13px; color: #8e8e8e"
                              >Max.KG</span
                            >
                          </v-flex>
                          <v-flex xs12>
                            <span> <b> {{ list.maxKg }} </b></span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span style="font-size: 13px; color: #8e8e8e"
                              >Amount</span
                            >
                          </v-flex>
                          <v-flex xs12>
                            <span> <b>{{ list.amount }}</b></span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <!-- </v-card-text>
    
              </v-card> -->
              <v-dialog v-model="editdialog" max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Edit Delivery Charge</span>
                  </v-card-title>
                  <v-card-text>
                    <v-layout justify-center wrap>
                      <v-flex xs12 sm6 md6 pa-2>
                        <v-text-field
                          class="homeText"
                          outlined
                          dense
                          readonly
                          v-model="editing.minKm"
                          label="Min. KM"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 pa-2>
                        <v-text-field
                          class="homeText"
                          outlined
                          dense
                          readonly
                          v-model="editing.maxKm"
                          label="Max. KM"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      wrap
                      justify-center
                      v-for="(item, i) in editing.weight"
                      :key="i"
                    >
                      <v-flex xs12 sm6 md4 pa-2>
                        <v-text-field
                          class="homeText"
                          outlined
                          dense
                          readonly
                          v-model="item.minKg"
                          label="Min. KG"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4 pa-2>
                        <v-text-field
                          class="homeText"
                          outlined
                          dense
                          readonly
                          v-model="item.maxKg"
                          label="Max. KG"
                        ></v-text-field>
                      </v-flex>
                       <v-flex xs12 sm6 md4 pa-2>
                        <v-text-field
                          class="homeText"
                          outlined
                          dense
                          v-model="item.amount"
                          label="Amount"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="editdialog = false"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="edit(editing._id)"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      editing: "",
      editId: "",
      dialog: false,
      addDialog: false,
      editdialog: false,
      deleteCategory: false,
      formCategory: false,
      categoryImg: null,
      sbId: null,
      attachments: null,
      attachmentsformData: new FormData(),
      subcategory: [],
      delivery: [],
      editingitem: [],
      editingWeight:[],
      name: "",
      hsnCode: "",
      hsnDescription: "",
      gstSlab1Percentage: "",
      gstSlab2Percentage: "",
      gstSlab2MinimumPrice: "",
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 20,
      page: 1,
      totalpages: 0,
      ItemsCount: [20, 30, 50, 100],
      msg: "",
      showsnackbar: false,
      timeout: 3000,
      Rules: [(v) => !!v || "Required"],
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    itemsPerPage: function() {
      this.getData();
    },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getData();
        // } else {
        //   this.page--;
        //   this.getcategory();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getData();
        // } else {
        //   this.page++;
        //   this.getcategory();
        // }
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/grocery/deliveryCharge/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          limit: this.itemsPerPage,
          page: this.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.delivery = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );
          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    editCategoryDialog(item) {
      this.editing = item;
      for(var i=0; i<this.editing.length; i++){
      this.editingWeight = this.editing[i].weight;}
      this.editdialog = true;
      this.name = item.name;
      this.hsnCode = item.hsnCode;
      this.gstSlab1Percentage = item.gstSlab1Percentage;
      this.gstSlab2Percentage = item.gstSlab2Percentage;
      this.gstSlab2MinimumPrice = item.gstSlab2MinimumPrice;
      this.editId = item._id;
    },
    edit(id) {
      this.addDialog = false;
      var data = {};
      data["minKm"] = this.editing.minKm;
      data["maxKm"] = this.editing.maxKm;
      data["weight"] = this.editing.weight;
      data["id"] = id;
      axios({
        url: "/grocery/deliveryCharge/edit",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = "Delivery Charge Edited";
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    rowClicked(item) {
      this.$router.push("/category/" + item._id);
    },
  },
};
</script>
<style>
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>

